<script setup lang="ts">
import large201 from '@/assets/images/linerichmenu/large_201.svg?url'
import large202 from '@/assets/images/linerichmenu/large_202.svg?url'
import large203 from '@/assets/images/linerichmenu/large_203.svg?url'
import large204 from '@/assets/images/linerichmenu/large_204.svg?url'
import large205 from '@/assets/images/linerichmenu/large_205.svg?url'
import large206 from '@/assets/images/linerichmenu/large_206.svg?url'
import large207 from '@/assets/images/linerichmenu/large_207.svg?url'
import small101 from '@/assets/images/linerichmenu/small_101.svg?url'
import small102 from '@/assets/images/linerichmenu/small_102.svg?url'
import small103 from '@/assets/images/linerichmenu/small_103.svg?url'
import small104 from '@/assets/images/linerichmenu/small_104.svg?url'
import small105 from '@/assets/images/linerichmenu/small_105.svg?url'
import type { LineRichMenuFormTemplateName } from './formSchema'
import { largeTemplateNames, smallTemplateNames } from './formSchema'

const props = defineProps<{
  templateName: LineRichMenuFormTemplateName
  actionCount: number
  uploadedImageSize: 'large' | 'small' | null
}>()

const emit = defineEmits<{
  (e: 'update:templateName', value: string): void
  (e: 'update:actionCount', value: number): void
}>()

const templateUrl = (templateName: LineRichMenuFormTemplateName) => {
  switch (templateName) {
    case 'large_201':
      return large201
    case 'large_202':
      return large202
    case 'large_203':
      return large203
    case 'large_204':
      return large204
    case 'large_205':
      return large205
    case 'large_206':
      return large206
    case 'large_207':
      return large207
    case 'small_101':
      return small101
    case 'small_102':
      return small102
    case 'small_103':
      return small103
    case 'small_104':
      return small104
    case 'small_105':
      return small105
  }
}

const update = (templateName: LineRichMenuFormTemplateName) => {
  if (
    props.uploadedImageSize === 'large' &&
    !templateName.startsWith('large')
  ) {
    alert(
      'このテンプレートは画像サイズが横幅 1200px 縦幅 405px である必要があります。'
    )

    return
  }
  if (
    props.uploadedImageSize === 'small' &&
    !templateName.startsWith('small')
  ) {
    alert(
      'このテンプレートは画像サイズが横幅 1200px 縦幅 810px である必要があります。'
    )

    return
  }

  emit('update:templateName', templateName)
}
</script>

<template>
  <section>
    <p :class="$style.sectionTitle">テンプレートを選択</p>
    <div :class="$style.largeSectionContent">
      <div :class="$style.largeImageContainer">
        <label
          v-for="templateName of largeTemplateNames"
          :key="templateName"
          :class="$style.templateLargeLabel"
        >
          <input
            type="radio"
            name="template"
            :class="$style.templateInput"
            :checked="props.templateName === templateName"
            @change="update(templateName)"
          />
          <img
            :src="templateUrl(templateName)"
            :class="{
              [$style.selected]: props.templateName === templateName,
            }"
          />
        </label>
      </div>
    </div>
    <div :class="$style.smallSectionContent">
      <div :class="$style.smallImageContainer">
        <label
          v-for="templateName of smallTemplateNames"
          :key="templateName"
          :class="$style.templateSmallLabel"
        >
          <input
            type="radio"
            name="template"
            :class="$style.templateInput"
            :checked="props.templateName === templateName"
            @change="update(templateName)"
          />
          <img
            :src="templateUrl(templateName)"
            :class="{
              [$style.selected]: props.templateName === templateName,
            }"
          />
        </label>
      </div>
    </div>
  </section>
</template>

<style module lang="scss">
.sectionTitle {
  font-size: 18px;
  font-weight: bold;
}

.largeSectionContent {
  margin-top: 16px;
}

.smallSectionContent {
  margin-top: 40px;
}

.largeImageContainer {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.smallImageContainer {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.templateLargeLabel {
  cursor: pointer;
  width: 160px;
  height: 108px;
}

.templateSmallLabel {
  cursor: pointer;
  width: 160px;
  height: 54px;
}

.templateInput {
  display: none;
}

.selected {
  border: 2px solid $color-okaneko-blue;
}
</style>
